import Link from './link';
import Media from './media';
import Richtext from './richtext';

export default class Tile {
  description: Richtext | null;
  id?: string;
  mainMedia: Media | null;
  link: Link | null;
  secondaryMedia: Media | null;
  title: string;
  titleColor: string;

  constructor(props: any) {
    this.description = props.description
      ? new Richtext(props.description)
      : null;
    this.id = props.sys && props.sys.id ? props.sys.id : undefined;
    this.mainMedia = props.mainMedia ? new Media(props.mainMedia) : null;
    this.link = props.link ? new Link(props.link) : null;
    this.secondaryMedia = props.secondaryImage
      ? new Media(props.secondaryImage)
      : null;
    this.title = props.title;
    this.titleColor = props.titleColor;
  }
}
